import React, { useMemo } from 'react';
import Icon, { IconType } from 'components/Icon';
import { Tooltip } from 'components/Widget/Tooltip';
import * as S from './styles';

interface NavbarButtonProps {
	icon?: IconType;
	onClick?: () => void;
	active?: boolean;
	selected?: boolean;
	disabled?: boolean;
	tooltip?: string;
	tooltipId?: string;
	children?: React.ReactNode;
}

const NavbarButton = ({
	icon,
	onClick,
	active,
	selected,
	disabled,
	tooltip,
	tooltipId,
	children,
}: NavbarButtonProps) => {
	const finalTooltipId = useMemo(() => {
		if (tooltipId) return tooltipId;
		if (tooltip) return `navbar-button-tooltip-${Math.random().toString(36).substr(2, 9)}`;
		return undefined;
	}, [tooltipId, tooltip]);

	return (
		<>
			{tooltip && finalTooltipId && <Tooltip placement="bottom" id={finalTooltipId} />}
			<S.Base
				onClick={onClick}
				active={active}
				selected={selected}
				disabled={disabled}
				data-tooltip-id={finalTooltipId}
				data-tooltip-content={tooltip}
			>
				{icon && <Icon type={icon} width={16} height={16} />}
				{children}
			</S.Base>
		</>
	);
};

export default NavbarButton;
